import { render } from "./ChildrenContainerPropsCmp.vue?vue&type=template&id=6f88cda9"
import script from "./ChildrenContainerPropsCmp.vue?vue&type=script&lang=js"
export * from "./ChildrenContainerPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__